<template>
	<div class="form-group group-checkbox">
		<label :for="name">{{ placeholder }}</label>
		<div class="input-toggle">
			<input type="checkbox" :name="name" :id="name" :checked="value" @input="$emit('input', $event.target.checked)">
			<label :for="name"></label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules'
	],
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputToggle.vue